import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Route, Redirect, useLocation, matchPath } from 'react-router-dom';
import { extendedPageList } from '#component/user/pages';

const ProtectedRoute = ({ component: Component, render, ...rest }) => {
  const { pathname } = useLocation();
  const { userType, id, defaultPage } = useSelector(s => s.account, shallowEqual);
  const projects = useSelector(s => s.account.directProjects, shallowEqual);

  const userRootProject = projects?.find(p => p.level === 0);

  if (!id) return null;

  const mainPage = defaultPage || '/dashboard';
  const pagesList = extendedPageList(userType, id, userRootProject);
  const userHasPermission = pagesList.some(p => matchPath(pathname, p.route));

  return (
    <Route
      {...rest}
      render={props =>
        (userHasPermission ?
          render ? render(props) : <Component {...props} /> :
          <Redirect to={mainPage} />)}
    />
  );
};

export default ProtectedRoute;
